import { Suspense, useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import routes from '../config/routeConfig';
import PublicRoute from './PublicRoute';
import ProtectedRoute from './ProtectedRoute';
import { Loader2 } from 'lucide-react';

// Loading component for Suspense fallback
const Loading = () => (
    <div className="flex items-center justify-center h-screen">
        <Loader2 className="animate-spin w-10 h-10" />
    </div>
);

/**
 * Main routing component
 * Renders all routes based on the configuration
 */
const AppRoutes = () => {

    return (
        <Suspense fallback={ <Loading /> }>
            <Routes>
                { routes.map((route) => {
                    const { path, element: Component, public: isPublic, roles, permissions } = route;

                    // Determine which wrapper to use based on whether the route is public or protected
                    const RouteWrapper = isPublic ? PublicRoute : ProtectedRoute;

                    return (
                        <Route
                            key={ path }
                            path={ path }
                            element={
                                <RouteWrapper
                                    component={ Component }
                                    roles={ roles }
                                    permissions={ permissions }
                                />
                            }
                        />
                    );
                }) }
            </Routes>
        </Suspense>
    );
};

export default AppRoutes;
